module.exports = __webpack_public_path__ + "img/icon-success.abf2e7cb.png";